<template>
  <div v-show="loading">
    <div class="el-message el-message--info" v-show="status === 'loading'">
      <img class="el-message__icon" width="12" height="12" src="./loading.gif">
      <p class="el-message__content">{{ title }}</p>
    </div>
    <div class="el-message el-message--success" v-show="status === 'success'">
      <i class="el-message__icon el-icon-success"></i>
      <p class="el-message__content">操作成功</p>
    </div>
    <div class="el-message el-message--error" v-show="status === 'failed'">
      <i class="el-message__icon el-icon-error"></i>
      <p class="el-message__content">{{ failedTxt }}</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Loading'
    },
    status: {
      type: String,
      default: 'loading'
    },
    failedTxt: {
      type: String,
      default: '操作失败'
    },
  },
  data(){
    return {
      base_showLoading:false,
      base_title:"loading",
      base_status:"loading",
      base_failedTxt:"操作失败",
      base_duration: 3000,
      propsFlag:true,
    }
  },
  created(){
    if (this.propsFlag) {
      this.base_showLoading = loading;
      this.base_title = title;
      this.base_status = status;
      this.base_failedTxt = failedTxt;
    }
  },
  mounted(){
    // if (this.status === "failed") {
      setTimeout(() => {
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      }, this.duration);
    // }
  },
  methods:{},
  watch:{
    loading(newVAl){
      if (!this.loading) {
        this.$emit("leave")
      }
    },

  }
}
</script>
<style lang="scss" scoped>

.loading {
  width: 100%;
  text-align: center;
  position: absolute;

  .desc {
    line-height: 20px;
    font-size: 16px;
    color: #409eff;
  }
}
</style>
